export default __webpack_public_path__ + "static/media/banner-ielts.73ff824e.jpg";